import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { EmailTemplate, Placeholder, PlaceholderByRecipientType } from '../../../store/email/types';
import { InputText } from '../../ui';
import emailSlice from '../../../store/email/slice';
import { selectEmailState } from '../../../store/selectors';
import EmailForm from '../../EmailForm/EmailForm';
import { useTranslation } from 'react-i18next';

interface Props extends SimpleDialogProps {
  initialValue: EmailTemplate;
  placeholdersByRecipientType: PlaceholderByRecipientType;
  updateEmailTemplateAction: (data: EmailTemplate) => void;
  createEmailTemplateAction: (data: EmailTemplate) => void;
}

const EmailTemplateDialog: React.FC<Props> = ({
  initialValue,
  placeholdersByRecipientType,
  updateEmailTemplateAction,
  createEmailTemplateAction,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<EmailTemplate>(initialValue);

  const isEdit = data.id > 0;

  const placeholders: { [key in string]: Placeholder } = {};
  Object.values(placeholdersByRecipientType)
    .flat()
    .forEach((placeholder) => {
      placeholders[placeholder.value] = placeholder;
    });

  return (
    <SimpleDialog
      {...rest}
      title={isEdit ? t('Edit template') : t('New template')}
      okButtonText={t('Save')}
      handleOk={() => (isEdit ? updateEmailTemplateAction(data) : createEmailTemplateAction(data))}
      disableOkButton={!data.name || !data.subject || !data.body}
    >
      <div className="flex flex-col">
        <InputText
          label={t('Name')}
          value={data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
          className="mb-4"
        />

        <EmailForm
          onChange={(value) => setData({ ...data, body: value.body, subject: value.subject })}
          placeholders={Object.values(placeholders)}
          value={{ subject: data.subject, body: data.body }}
          templatesById={{}}
          hideTemplates={true}
        />
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({
  placeholdersByRecipientType: selectEmailState(state).placeholdersByRecipientType,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updateEmailTemplateAction: (data: EmailTemplate) => dispatch(emailSlice.actions['TEMPLATES:UPDATE'](data)),
  createEmailTemplateAction: (data: EmailTemplate) => dispatch(emailSlice.actions['TEMPLATES:CREATE'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateDialog);
